import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  Tabs, Form, Button, Modal, Input,
} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import {
  faSignOutAlt, faArrowLeft, faSearch, faTimes,
} from '@fortawesome/free-solid-svg-icons';
import {
  getClientesAction,
  resetClientes,
} from '../../../state/actions/creators/clientes/clientes.actioncreator';
import {
  getProveedoresAction,
  resetProveedores,
} from '../../../state/actions/creators/proveedores/proveedores.actioncreator';
import {
  getRrhhAction,
  resetRrhh,
} from '../../../state/actions/creators/rrhh/rrhh.actioncreator';
import {
  getTipologiasAction,
} from '../../../state/actions/creators/tipologias/tipologias.actioncreator';
import {
  getProcesosAction,
  resetProcesos,
} from '../../../state/actions/creators/procesos/procesos.actioncreator';
import {
  DatosTab, ClientesTab, ProveedoresTab, RrhhTab, TipologiasTab, ProcesosTab,
} from '../containers';
import {
  Box, Text,
} from '../../shared/components';
import debounce from '../../../helpers/debounce';
import {
  getNoConformidadAction,
  crearNoConformidadAction,
  setMostrarBotonGuardarAction,
  setMostrarBotonTipologiasAction,
  setActiveTabFormAction,
  actualizarNoConformidadAction,
  setMostrarBotonAfectadosAction,
  setMostrarBarraBotonesFormNcAction,
} from '../../../state/actions/creators/noconformidades/noconformidades.actioncreator';
import HeaderPageLayout from '../../app/layout/headerPage.layout';
import {
  logoutAction,
} from '../../../state/actions/creators/auth.actioncreator';

const { TabPane } = Tabs;

const FILTRO_CLIENTES = '1';
const FILTRO_PROVEEDORES = '2';
const FILTRO_RRHH = '3';
const FILTRO_PROCESOS = '4';

const TAB_DATOS_ID = '1';
const TAB_CLIENTES_ID = '2';
const TAB_PROVEEDORES_ID = '3';
const TAB_RRHH_ID = '4';
const TAB_PROCESOS_ID = '5';
const TAB_TIPOLOGIAS_ID = '6';

const SEDE_BASE = '1';

function prepararFiltroTipoTipologia(arrayDatos, tipoFiltro, arrayFiltros) {
  if (typeof (arrayDatos) !== 'undefined') {
    const elementosSeleccionados = arrayDatos.filter(valor => valor === true);
    if (elementosSeleccionados.length > 0) {
      arrayFiltros.push(tipoFiltro);
    }
  }
  return arrayFiltros;
}


class FormNoConformidad extends Component {
  debouncedSearch = debounce((text, me) => {
    const {
      noConformidades, getClientesAction, getProveedoresAction, getRrhhAction,
      getProcesosAction, resetClientes, resetProveedores, resetRrhh, resetProcesos,
    } = me.props;
    const { activeTabFormNc } = noConformidades;
    switch (activeTabFormNc) {
      case TAB_CLIENTES_ID:
        resetClientes();
        getClientesAction(1, 0, 25, 1, false, 'listar', text);
        break;
      case TAB_PROVEEDORES_ID:
        resetProveedores();
        getProveedoresAction(1, 0, 25, 1, true, 'listar', text);
        break;
      case TAB_RRHH_ID:
        resetRrhh();
        getRrhhAction(1, 0, 25, 1, 'listar', text);
        break;
      case TAB_PROCESOS_ID:
        resetProcesos();
        getProcesosAction(1, 0, 25, true, false, 'listado_basico', 1, true, text);
        break;
      default:
        break;
    }


    // const { getNoConformidadesAction, resetNoConformidades } = this.props;
    // resetNoConformidades();
    // getNoConformidadesAction(1, 0, 25, text);
  }, 500);

  constructor(props) {
    super();
    this.state = {
      classNameTabs: '',
      searchOpened: false,
      searchText: '',
      modalLogout: null,
      clientesSeleccionados: [],
      verClientesSeleccionados: false,
      proveedoresSeleccionados: [],
      verProveedoresSeleccionados: false,
      rrhhSeleccionados: [],
      verRrhhSeleccionados: false,
      procesosSeleccionados: [],
      verProcesosSeleccionados: false,

    };
  }

  componentWillMount() {
    const {
      noConformidades, getNoConformidadAction, match: { params: { id }, form },
      resetClientes, resetProveedores, resetRrhh, resetProcesos,
    } = this.props;
    const { seleccionada } = noConformidades;

    if (seleccionada !== null && id !== null) {
      getNoConformidadAction(id);
      resetClientes();
      resetProveedores();
      resetRrhh();
      resetProcesos();
    }

    this.onSelectTab(TAB_DATOS_ID);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    // form.validateFields();
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  getActionButtons() {
    return (
      <Box style={{
        display: 'flex', justifyContent: 'space-between', width: '100%',
      }}
      >
        <Box flex={1}>
          <Button
            type="link"
            shape="circle"
            onClick={() => {
              this.setState({ searchOpened: true });
            }}
          >
            {' '}
            <FontAwesomeIcon icon={faSearch} />
          </Button>
        </Box>
        <Box id="secondBtnHeader" flex={1}>
          <Button type="link" shape="circle" onClick={() => this.confirm()}>
            {' '}
            <FontAwesomeIcon icon={faSignOutAlt} />
          </Button>
        </Box>
      </Box>
    );
  }

  handleScroll = () => {
    if (document.documentElement.scrollTop + document.documentElement.clientHeight
      >= document.documentElement.scrollHeight - 100) {
      this.obtenerSucesivosElementos();
    }
  };


  onClickElegirAfectados() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.setState({ classNameTabs: 'beating-text' });
  }

  onSelectTab(tabKey) {
    const {
      setMostrarBotonGuardarAction, getTipologiasAction,
      setMostrarBotonTipologiasAction, setActiveTabFormAction,
      form, getClientesAction, getProveedoresAction, getRrhhAction,
      noConformidades: { seleccionada: { sede: sedeSeleccionada } },
      setMostrarBotonAfectadosAction, getProcesosAction,
      resetClientes, resetProveedores, resetRrhh, resetProcesos,
    } = this.props;
    const valoresForm = form.getFieldsValue();
    const { sede } = valoresForm;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    let formularioValido = true;

    if ((valoresForm.nombre === undefined) || (valoresForm.nombre === '')
      || (typeof Array.isArray === 'undefined') || (valoresForm.tipologias === undefined)
        || ((valoresForm.tipologias !== undefined)
          && (valoresForm.tipologias.filter(valor => valor === true).length === 0))
    ) {
      formularioValido = false;
    }

    setActiveTabFormAction(tabKey);
    if ((tabKey === TAB_DATOS_ID) || (tabKey === TAB_TIPOLOGIAS_ID)) {
      setMostrarBotonGuardarAction(formularioValido);
    } else {
      setMostrarBotonGuardarAction(false);
    }
    setMostrarBarraBotonesFormNcAction(false);

    switch (tabKey) {
      case TAB_TIPOLOGIAS_ID:
        getTipologiasAction(1, 0, 9999, this.prepararFiltrosTipologias());
        setMostrarBotonTipologiasAction(false);
        setMostrarBotonAfectadosAction(false);
        this.setState({ classNameTabs: '' });
        break;
      case TAB_CLIENTES_ID:
      case TAB_PROVEEDORES_ID:
      case TAB_RRHH_ID:
      case TAB_PROCESOS_ID:
        setMostrarBotonTipologiasAction(true);
        setMostrarBotonAfectadosAction(false);
        this.setState({ classNameTabs: '' });
        break;
      case TAB_DATOS_ID:
        resetClientes();
        resetProveedores();
        resetRrhh();
        resetProcesos();
        getClientesAction(1, 0, 25, (sede || sedeSeleccionada || SEDE_BASE), false, 'listar');
        getProveedoresAction(1, 0, 25, (sede || sedeSeleccionada || SEDE_BASE), true, 'listar');
        getRrhhAction(1, 0, 25, (sede || sedeSeleccionada || SEDE_BASE), 'listar');
        getProcesosAction(1, 0, 25, true, false, 'listado_basico', (sede || sedeSeleccionada || SEDE_BASE), true);
        setMostrarBotonTipologiasAction(true);
        setMostrarBotonAfectadosAction(false);
        this.setState({ classNameTabs: '' });

        break;
      default:
        break;
    }
  }

  onChangeSede(value) {
    const {
      getClientesAction, getProveedoresAction, getRrhhAction, getProcesosAction,
      resetClientes, resetProveedores, resetRrhh, resetProcesos,
    } = this.props;
    resetClientes();
    resetProveedores();
    resetRrhh();
    resetProcesos();
    getClientesAction(1, 0, 25, (value || SEDE_BASE), false, 'listar');
    getProveedoresAction(1, 0, 25, (value || SEDE_BASE), true, 'listar');
    getRrhhAction(1, 0, 25, (value || SEDE_BASE), 'listar');
    getProcesosAction(1, 0, 25, true, false, 'listado_basico', (value || SEDE_BASE), true);
  }

  onChangeTipologias(e) {
    const {
      setMostrarBotonGuardarAction, form,
    } = this.props;
    const valoresForm = form.getFieldsValue();
    let formularioValido = true;

    if ((valoresForm.nombre === undefined) || (valoresForm.nombre === '')
      || (typeof Array.isArray === 'undefined') || (valoresForm.tipologias === undefined)
        || ((valoresForm.tipologias !== undefined)
          && (((valoresForm.tipologias.filter(valor => valor === true).length === 0
          || valoresForm.tipologias.filter(valor => valor === true).length === 1) && !e.target.checked)))
    ) {
      formularioValido = false;
    }

    setMostrarBotonGuardarAction(formularioValido);
  }

  onChangeClientesSeleccionados(e) {
    debugger;
    const cliente = e.target.idCliente;
    const estaSeleccionado = e.target.checked;
    const { clientesSeleccionados } = this.state;
    if (estaSeleccionado) {
      this.state.clientesSeleccionados[this.state.clientesSeleccionados.length] = cliente;
    } else {
      for (let i = 0; i < clientesSeleccionados.length; i += 1) {
        if (clientesSeleccionados[i] === cliente) {
          clientesSeleccionados.splice(i, 1);
          break;
        }
      }
      this.state.clientesSeleccionados = clientesSeleccionados;
    }
  }

  onChangeProveedoresSeleccionados(e) {
    debugger;
    const proveedor = e.target.idProveedor;
    const estaSeleccionado = e.target.checked;
    const { proveedoresSeleccionados } = this.state;
    if (estaSeleccionado) {
      this.state.proveedoresSeleccionados[this.state.proveedoresSeleccionados.length] = proveedor;
    } else {
      for (let i = 0; i < proveedoresSeleccionados.length; i += 1) {
        if (proveedoresSeleccionados[i] === proveedor) {
          proveedoresSeleccionados.splice(i, 1);
          break;
        }
      }
      this.state.proveedoresSeleccionados = proveedoresSeleccionados;
    }
  }

  onChangeRrhhSeleccionados(e) {
    debugger;
    const rrhh = e.target.idRrhh;
    const estaSeleccionado = e.target.checked;
    const { rrhhSeleccionados } = this.state;
    if (estaSeleccionado) {
      this.state.rrhhSeleccionados[this.state.rrhhSeleccionados.length] = rrhh;
    } else {
      for (let i = 0; i < rrhhSeleccionados.length; i += 1) {
        if (rrhhSeleccionados[i] === rrhh) {
          rrhhSeleccionados.splice(i, 1);
          break;
        }
      }
      this.state.rrhhSeleccionados = rrhhSeleccionados;
    }
  }

  onChangeProcesosSeleccionados(e) {
    debugger;
    const proceso = e.target.idProceso;
    const estaSeleccionado = e.target.checked;
    const { procesosSeleccionados } = this.state;
    if (estaSeleccionado) {
      this.state.procesosSeleccionados[this.state.procesosSeleccionados.length] = proceso;
    } else {
      for (let i = 0; i < procesosSeleccionados.length; i += 1) {
        if (procesosSeleccionados[i] === proceso) {
          procesosSeleccionados.splice(i, 1);
          break;
        }
      }
      this.state.procesosSeleccionados = procesosSeleccionados;
    }
  }

  onFocusOrBlurField(mostrarBotones) {
    const {
      setMostrarBarraBotonesFormNcAction, form,
      setMostrarBotonGuardarAction,
    } = this.props;
    const valoresForm = form.getFieldsValue();
    let formularioValido = true;

    if ((valoresForm.nombre === undefined) || (valoresForm.nombre === '')
       || (typeof Array.isArray === 'undefined') || (valoresForm.tipologias === undefined)
       || ((valoresForm.tipologias !== undefined)
        && (valoresForm.tipologias.filter(valor => valor === true).length === 0))
    ) {
      formularioValido = false;
    }

    setMostrarBotonGuardarAction(formularioValido);
    setMostrarBarraBotonesFormNcAction(mostrarBotones);
  }


  getNavigationButtons() {
    return (
      <Box>
        <Button type="link" shape="circle" onClick={() => this.volverAtras()}>
          {' '}
          <FontAwesomeIcon icon={faArrowLeft} />
        </Button>
      </Box>
    );
  }

  crearNC() {
    const { form, crearNoConformidadAction } = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        crearNoConformidadAction(values);
      }
    });
  }

  actualizarNC() {
    const { form, actualizarNoConformidadAction } = this.props;

    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const {
          clientes, proveedores, rrhh, tipologias, procesos,
        } = values;
        actualizarNoConformidadAction(values);
      }
    });
  }


  obtenerSucesivosElementos() {
    const {
      clientes, getClientesAction,
      noConformidades, form,
      proveedores, getProveedoresAction,
      rrhh, getRrhhAction,
      procesos, getProcesosAction,
    } = this.props;
    const { searchText } = this.state;
    let valoresCargadosPagina = null;
    const valoresForm = form.getFieldsValue();
    const { sede } = valoresForm;
    const {
      page: pageClientes, start: startClientes, limit: limitClientes, total: totalClientes,
    } = clientes;
    const {
      page: pageProveedores, start: startProveedores, limit: limitProveedores, total: totalProveedores,
    } = proveedores;
    const {
      page: pageRrhh, start: startRrhh, limit: limitRrhh, total: totalRrhh,
    } = rrhh;
    const {
      page: pageProcesos, start: startProcesos, limit: limitProcesos, total: totalProcesos,
    } = procesos;
    const { activeTabFormNc, seleccionada: { sede: sedeSeleccionada } } = noConformidades;

    debugger;
    switch (activeTabFormNc) {
      case TAB_CLIENTES_ID:
        valoresCargadosPagina = pageClientes * limitClientes;
        if (valoresCargadosPagina < totalClientes) {
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = document.documentElement.scrollTop - 200;
          getClientesAction(pageClientes + 1, startClientes + limitClientes, limitClientes, (sede || sedeSeleccionada || SEDE_BASE), false, 'listar', searchText);
        }
        break;
      case TAB_PROVEEDORES_ID:
        valoresCargadosPagina = pageProveedores * limitProveedores;
        if (valoresCargadosPagina < totalProveedores) {
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = document.documentElement.scrollTop - 200;
          getProveedoresAction(pageProveedores + 1, startProveedores + limitProveedores, limitProveedores, (sede || sedeSeleccionada || SEDE_BASE), true, 'listar', searchText);
        }
        break;
        break;
      case TAB_RRHH_ID:
        valoresCargadosPagina = pageRrhh * limitRrhh;
        if (valoresCargadosPagina < totalRrhh) {
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = document.documentElement.scrollTop - 200;
          getRrhhAction(pageRrhh + 1, startRrhh + limitRrhh, limitRrhh, (sede || sedeSeleccionada || SEDE_BASE), 'listar', searchText);
        }
        break;
      case TAB_PROCESOS_ID:
        valoresCargadosPagina = pageProcesos * limitProcesos;
        if (valoresCargadosPagina < totalProcesos) {
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = document.documentElement.scrollTop - 200;
          getProcesosAction(pageProcesos + 1, startProcesos + limitProcesos, limitProcesos, true, false, 'listado_basico', (sede || sedeSeleccionada || SEDE_BASE), true, searchText);
        }
        break;
      default:
        break;
    }
  }

  overrideHeader() {
    const { searchOpened, searchText } = this.state;
    if (!searchOpened) return undefined;
    return (
      <>
        <Box flex={9} pl={4}>
          <Input onChange={event => this.handleSearh(event.target.value)} value={searchText} autoFocus className="headerSearchInput" placeholder="Buscar" />
        </Box>
        <Box flex={1}>
          <Button pr={8} type="link" shape="circle" onClick={() => this.onCloseSearch()}>
            {' '}
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </Box>
      </>
    );
  }

  handleSearh(text) {
    this.setState({ searchText: text });
    if ((text.length > 3) || (text.length === 0)) {
      this.debouncedSearch(text, this);
    }
  }

  onCloseSearch() {
    this.handleSearh('');
    this.setState({ searchOpened: false });
  }

  prepararFiltrosTipologias() {
    const {
      form, noConformidades: {
        seleccionada:
        {
          clientes, proveedores, usuarios_implicados: rrhh, procesos,
        },
      },
    } = this.props;
    const valoresForm = form.getFieldsValue();
    let filtroFormateado = null;
    let filtros = [];
    if (typeof (valoresForm.clientes) !== 'undefined') {
      filtros = prepararFiltroTipoTipologia(
        valoresForm.clientes,
        FILTRO_CLIENTES,
        filtros,
      );
    } else if ((typeof (valoresForm.clientes) === 'undefined')
      && (typeof (clientes) !== 'undefined') && (clientes !== '')) {
      filtros.push(FILTRO_CLIENTES);
    }

    if (typeof (valoresForm.proveedores) !== 'undefined') {
      filtros = prepararFiltroTipoTipologia(
        valoresForm.proveedores,
        FILTRO_PROVEEDORES,
        filtros,
      );
    } else if ((typeof (valoresForm.proveedores) === 'undefined')
      && (typeof (proveedores) !== 'undefined') && (proveedores !== '')) {
      filtros.push(FILTRO_PROVEEDORES);
    }

    if (typeof (valoresForm.rrhh) !== 'undefined') {
      filtros = prepararFiltroTipoTipologia(
        valoresForm.rrhh,
        FILTRO_RRHH,
        filtros,
      );
    } else if ((typeof (valoresForm.rrhh) === 'undefined')
      && (typeof (rrhh) !== 'undefined') && (rrhh !== '')) {
      filtros.push(FILTRO_RRHH);
    }

    if (typeof (valoresForm.procesos) !== 'undefined') {
      filtros = prepararFiltroTipoTipologia(
        valoresForm.procesos,
        FILTRO_PROCESOS,
        filtros,
      );
    } else if ((typeof (valoresForm.procesos) === 'undefined')
      && (typeof (procesos) !== 'undefined') && (procesos !== '')) {
      filtros.push(FILTRO_PROCESOS);
    }

    if (filtros.length > 0) {
      filtroFormateado = [{ property: 'tipos_tipologias', value: filtros.join(',') }];
    }
    return filtroFormateado;
  }

  volverAtras() {
    const { history } = this.props;
    history.push('/#/noconformidades/listar');
  }

  confirm() {
    this.setState({
      modalLogout: (Modal.confirm({
        title: '¿Seguro que quieres salir de Qualitas?',
        content: '',
        okText: 'Salir',
        cancelText: 'Cancelar',
        icon: null,
        onOk: e => this.okLogout(e),
      })),
    });
  }

  okLogout(e) {
    const { logoutAction } = this.props;
    const { modalLogout } = this.state;
    if (modalLogout) modalLogout.destroy();
    logoutAction();
  }

  verSeleccionadosOTodos() {
    const {
      noConformidades, getClientesAction, getProveedoresAction, getRrhhAction,
      getProcesosAction, resetClientes, resetProveedores, resetRrhh, resetProcesos, form,
    } = this.props;
    const { activeTabFormNc, seleccionada: { sede: sedeSeleccionada } } = noConformidades;
    const { searchText } = this.state;
    const {
      verClientesSeleccionados, clientesSeleccionados,
      verProveedoresSeleccionados, proveedoresSeleccionados,
      verRrhhSeleccionados, rrhhSeleccionados,
      verProcesosSeleccionados, procesosSeleccionados,
    } = this.state;
    const valoresForm = form.getFieldsValue();
    const { sede } = valoresForm;
    const { seleccionada } = noConformidades;
    let {
      clientes: clientesArray, proveedores: proveedoresArray,
      usuarios_implicados: rrhhArray, procedimientos: procesosArray,
    } = seleccionada;
    let clientesSeleccionadosTodos = [];
    let proveedoresSeleccionadosTodos = [];
    let rrhhSeleccionadosTodos = [];
    let procesosSeleccionadosTodos = [];

    switch (activeTabFormNc) {
      case TAB_CLIENTES_ID:
        resetClientes();
        this.setState({ verClientesSeleccionados: !verClientesSeleccionados });

        if (!verClientesSeleccionados) {
          clientesArray = (typeof (clientesArray) !== 'undefined') ? clientesArray : [];
          if (!Array.isArray(clientesArray)) {
            clientesArray = clientesArray.split(',');
          }
          if (clientesArray.length !== 0) {
            clientesSeleccionadosTodos = [...new Set([...clientesArray, ...clientesSeleccionados])];
          } else {
            clientesSeleccionadosTodos = clientesSeleccionados;
          }
          getClientesAction(1, 0, 25, (sede || sedeSeleccionada || SEDE_BASE), false, 'listar', searchText, clientesSeleccionadosTodos);
        } else {
          getClientesAction(1, 0, 25, (sede || sedeSeleccionada || SEDE_BASE), false, 'listar', searchText);
        }
        break;
      case TAB_PROVEEDORES_ID:
        resetProveedores();
        this.setState({ verProveedoresSeleccionados: !verProveedoresSeleccionados });

        if (!verProveedoresSeleccionados) {
          proveedoresArray = (typeof (proveedoresArray) !== 'undefined') ? proveedoresArray : [];
          if (!Array.isArray(proveedoresArray)) {
            proveedoresArray = proveedoresArray.split(',');
          }
          if (proveedoresArray.length !== 0) {
            proveedoresSeleccionadosTodos = [...new Set([...proveedoresArray, ...proveedoresSeleccionados])];
          } else {
            proveedoresSeleccionadosTodos = proveedoresSeleccionados;
          }
          getProveedoresAction(1, 0, 25, (sede || sedeSeleccionada || SEDE_BASE), true, 'listar', searchText, proveedoresSeleccionadosTodos);
        } else {
          getProveedoresAction(1, 0, 25, (sede || sedeSeleccionada || SEDE_BASE), true, 'listar', searchText);
        }
        break;
      case TAB_RRHH_ID:
        resetRrhh();
        this.setState({ verRrhhSeleccionados: !verRrhhSeleccionados });

        if (!verRrhhSeleccionados) {
          rrhhArray = (typeof (rrhhArray) !== 'undefined') ? rrhhArray : [];
          if (!Array.isArray(rrhhArray)) {
            rrhhArray = rrhhArray.split(',');
          }
          if (rrhhArray.length !== 0) {
            rrhhSeleccionadosTodos = [...new Set([...rrhhArray, ...rrhhSeleccionados])];
          } else {
            rrhhSeleccionadosTodos = rrhhSeleccionados;
          }
          getRrhhAction(1, 0, 25, (sede || sedeSeleccionada || SEDE_BASE), 'listar', searchText, rrhhSeleccionadosTodos);
        } else {
          getRrhhAction(1, 0, 25, (sede || sedeSeleccionada || SEDE_BASE), 'listar', searchText);
        }
        break;
      case TAB_PROCESOS_ID:
        resetProcesos();
        this.setState({ verProcesosSeleccionados: !verProcesosSeleccionados });

        if (!verProcesosSeleccionados) {
          procesosArray = (typeof (procesosArray) !== 'undefined') ? procesosArray : [];
          if (!Array.isArray(procesosArray)) {
            procesosArray = procesosArray.split(',');
          }
          if (procesosArray.length !== 0) {
            procesosSeleccionadosTodos = [...new Set([...procesosArray, ...procesosSeleccionados])];
          } else {
            procesosSeleccionadosTodos = procesosSeleccionados;
          }
          getProcesosAction(1, 0, 25, true, false, 'listado_basico', (sede || sedeSeleccionada || SEDE_BASE), true, searchText, procesosSeleccionadosTodos);
        } else {
          getProcesosAction(1, 0, 25, true, false, 'listado_basico', (sede || sedeSeleccionada || SEDE_BASE), true, searchText);
        }
        break;
      default:
        break;
    }
  }

  render() {
    const {
      history, noConformidades, usuarioNombre, usuarioId, clientes, proveedores,
      rrhh, form, sedes, tipologias, resultado, procesos,
    } = this.props;
    const {
      mostrarGuardarNc, mostrarBotonTipologiasNc, activeTabFormNc, seleccionada,
      mostrarBotonAfectadosNc, mostrarBotonBarraBotonesFormNc,
    } = noConformidades;

    const {
      classNameTabs, verClientesSeleccionados, verProveedoresSeleccionados,
      verRrhhSeleccionados, verProcesosSeleccionados,
    } = this.state;

    const { nuevoId } = resultado || { nuevoId: undefined };
    if (nuevoId) {
      history.push(`/noconformidades/mostrar/${nuevoId}`);
    }

    const tituloFormulario = (seleccionada.hasOwnProperty('id')) ? 'Edición de NC' : 'Nueva NC';

    return (
      <HeaderPageLayout
        overrideHeader={this.overrideHeader()}
        title={tituloFormulario}
        p={2}
        actionButtons={this.getActionButtons()}
        navigationButton={this.getNavigationButtons()}
      >
        <Box style={{ marginBottom: '170px' }}>
          <Form
            className="noconformidades-form"
            onSubmit={(e) => {
              const { noConformidades } = this.props;
              const { form, seleccionada } = noConformidades;
              const { id } = seleccionada;
              e.preventDefault();
              if (seleccionada && (id)) {
                this.actualizarNC();
              } else {
                this.crearNC();
              }
            }}
          >
            <Tabs className={classNameTabs} defaultActiveKey="1" activeKey={activeTabFormNc} tabPosition="top" tabBarStyle={{ backgroundColor: 'white' }} onChange={e => this.onSelectTab(e)}>
              <TabPane eventKey="datosNc" tab="Datos" key={TAB_DATOS_ID}>
                <DatosTab
                  usuarioNombre={usuarioNombre}
                  usuarioId={usuarioId}
                  sedes={sedes}
                  form={form}
                  noConformidades={noConformidades}
                  onChangeSede={value => this.onChangeSede(value)}
                  history={history}
                  setMostrarBarraBotonesFormNcAction={mostrarBotones => this.onFocusOrBlurField(mostrarBotones)}
                />
              </TabPane>

              <TabPane forceRender eventKey="clientesNc" tab="Clientes" key={TAB_CLIENTES_ID}>
                <Box>
                  <Button style={{ position: 'absolute', right: '0', marginTop: '8px' }} type="link" onClick={() => this.verSeleccionadosOTodos()}>
                    {(!verClientesSeleccionados) ? 'Ver Seleccionados' : 'Ver Todos'}
                  </Button>
                </Box>
                <ClientesTab
                  clientes={((clientes) || [])}
                  form={form}
                  noConformidades={noConformidades}
                  onChangeClientesSeleccionados={e => this.onChangeClientesSeleccionados(e)}
                  clientesSeleccionados={this.state.clientesSeleccionados}
                  inicializarClientesSeleccionados={(cl) => { debugger; }}
                />
              </TabPane>

              <TabPane forceRender eventKey="proveedoresNc" tab="Proveedores" key={TAB_PROVEEDORES_ID}>
                <Box>
                  <Button style={{ position: 'absolute', right: '0', marginTop: '8px' }} type="link" onClick={() => this.verSeleccionadosOTodos()}>
                    {(!verProveedoresSeleccionados) ? 'Ver Seleccionados' : 'Ver Todos'}
                  </Button>
                </Box>
                <ProveedoresTab
                  proveedores={proveedores}
                  form={form}
                  noConformidades={noConformidades}
                  onChangeProveedoresSeleccionados={e => this.onChangeProveedoresSeleccionados(e)}
                  proveedoresSeleccionados={this.state.proveedoresSeleccionados}
                />
              </TabPane>

              <TabPane forceRender eventKey="rrhhNc" tab="RRHH Causantes" key={TAB_RRHH_ID}>
                <Box>
                  <Button style={{ position: 'absolute', right: '0', marginTop: '8px' }} type="link" onClick={() => this.verSeleccionadosOTodos()}>
                    {(!verRrhhSeleccionados) ? 'Ver Seleccionados' : 'Ver Todos'}
                  </Button>
                </Box>
                <RrhhTab
                  rrhh={rrhh}
                  form={form}
                  noConformidades={noConformidades}
                  onChangeRrhhSeleccionados={e => this.onChangeRrhhSeleccionados(e)}
                  rrhhSeleccionados={this.state.rrhhSeleccionados}
                />
              </TabPane>

              <TabPane forceRender eventKey="procesosNc" tab="Procesos" key={TAB_PROCESOS_ID}>
                <Box>
                  <Button style={{ position: 'absolute', right: '0', marginTop: '8px' }} type="link" onClick={() => this.verSeleccionadosOTodos()}>
                    {(!verProcesosSeleccionados) ? 'Ver Seleccionados' : 'Ver Todos'}
                  </Button>
                </Box>
                <ProcesosTab
                  procesos={((procesos) || [])}
                  form={form}
                  noConformidades={noConformidades}
                  onChangeProcesosSeleccionados={e => this.onChangeProcesosSeleccionados(e)}
                  procesosSeleccionados={this.state.procesosSeleccionados}
                />
              </TabPane>

              <TabPane forceRender eventKey="tipologiasNc" tab="Tipologías" key={TAB_TIPOLOGIAS_ID}>
                <TipologiasTab
                  tipologias={tipologias}
                  form={form}
                  noConformidades={noConformidades}
                  onChangeTipologias={e => this.onChangeTipologias(e)}
                />
              </TabPane>
            </Tabs>
            <Form.Item className={(mostrarBotonBarraBotonesFormNc) ? 'botonesInferioresFlotantes' : 'desactivarBotonesInferioresFlotantes'}>
              <Box>
                {(mostrarBotonAfectadosNc) ? (
                  <Box p={5} py={5}>
                    <Button onClick={() => this.onClickElegirAfectados()} style={{ height: '60px' }} block type="secondary" htmlType="button" className="tipologias-nc-form-button">
                      <Text fontWeight="bold">Elegir tipologias</Text>
                    </Button>
                  </Box>
                ) : null}
                {(mostrarBotonTipologiasNc) ? (
                  <Box p={5} py={5}>
                    <Button onClick={() => this.onSelectTab(TAB_TIPOLOGIAS_ID)} style={{ height: '60px' }} block type="secondary" htmlType="button" className="tipologias-nc-form-button">
                      <Text fontWeight="bold">Elegir tipologias</Text>
                    </Button>
                  </Box>
                ) : null}
                {(mostrarGuardarNc) ? (
                  <Box px={5}>
                    <Button style={{ height: '60px' }} block type="primary" htmlType="submit" className="noconformidades-form-button">
                      <Text fontWeight="bold">Guardar no conformidad</Text>
                    </Button>
                  </Box>
                ) : null}
              </Box>
            </Form.Item>
          </Form>
        </Box>
      </HeaderPageLayout>
    );
  }
}


function mapStateToProps({
  noConformidades, auth: { user: { usuario: usuarioNombre, usuario_id: usuarioId } },
  clientes, proveedores, rrhh, sedes, tipologias, procesos,
}) {
  return {
    usuarioId,
    noConformidades,
    usuarioNombre,
    clientes,
    proveedores,
    rrhh,
    sedes,
    tipologias,
    procesos,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getClientesAction,
    getProveedoresAction,
    getRrhhAction,
    crearNoConformidadAction,
    setMostrarBotonGuardarAction,
    getTipologiasAction,
    setMostrarBotonTipologiasAction,
    setActiveTabFormAction,
    actualizarNoConformidadAction,
    logoutAction,
    getNoConformidadAction,
    setMostrarBotonAfectadosAction,
    setMostrarBarraBotonesFormNcAction,
    getProcesosAction,
    resetClientes,
    resetProveedores,
    resetRrhh,
    resetProcesos,
  }, dispatch);
}

const AntFormNoConformidad = Form.create({ name: 'noconformidades-form' })(FormNoConformidad);

export default connect(mapStateToProps, mapDispatchToProps)(AntFormNoConformidad);
